


























import Vue from 'vue'
export default Vue.extend({
    props: {
        //  The color theme applied to the button
        color: {
            type: String,
            default: 'primary'
        },
        //  A custom class we want to apply to the component
        customClass: {
            type: String,
            default: null
        },
        //  Determines if our button is disabled or not
        disabled: {
            type: Boolean,
            default: false
        },
        //  Determines if our button is in a fake disabled state or not
        disabledPopup: {
            type: Boolean,
            default: false
        },
        //  Our text we use for displaying why a button is disabled
        disabledPopupText: {
            type: String,
            default: null
        },
        //  The icon displayed in the button
        icon: {
            type: String,
            default: null
        },
        //  Determines if the 'loading' spinner is shown
        loading: {
            type: Boolean,
            default: false
        },
        //  Applies the 'outlined' style
        outlined: {
            type: Boolean,
            default: false
        },
        //  Applies the 'small' style to the button
        small: {
            type: Boolean,
            default: false
        },
        //  The text displayed in the button content
        text: {
            type: String,
            default: null
        },
        textColor: {
            type: String,
            default: null
        },
        //  The router path that the button navigates to
        to: {
            type: String,
            default: null
        },
        //  Text displayed in the button tooltip, also Determines if the button is a tooltip
        tooltip: {
            type: String,
            default: null
        },
        width: {
            type: String,
            default: null
        },
        //  Applies the 'x-small' style to the button
        xSmall: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isIcon(): boolean {
            //  If an icon is set, AND text does NOT exist, it is an icon button
            return this.icon && !this.text
        }
    },
    methods: {
        popDisabledPopup(): void {
            //  Open a dialog informing user they cannot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Button Disabled',
                text: this.disabledPopupText,
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        onClick(): void {
            //  Check if our button is disabled pseudo
            const disabled = this.disabledPopup

            //  If it is, then use our disabled popup
            if (disabled) return this.popDisabledPopup()

            //  Else, just emit the click event
            this.$emit('click')
        }
    }
})
